import APIService from "@/services/APIService.js"; 

export default {
  consultar (objCodigosMcpse) {
    return APIService.apiCall().post('/coge/consultar',JSON.stringify(objCodigosMcpse), {responseType: 'blob'})
  },
};